module.exports = __webpack_public_path__ + "static/media/hacker.72e98ed4.gif";